import React, { useState, useEffect, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import classNames from "classnames";
// import { Toast } from "primereact/toast";
import { toast } from "react-toastify";
// import './ToastDemo.css';
import appUrl from "../../../config/appUrl";
const AddEditBooth = ({ onHide, getBoothList, addEditBooth, boothId }) => {
  const [disable, setDisable] = useState();
  const [siteList, setSiteList] = useState([]);
  const [siteValue, setSitevalue] = useState(null);
  // const toast = useRef(null);

  // const showWarn = (msg) => {
  //   toast.current.show({
  //     severity: "warn",
  //     summary: "Warn Message",
  //     detail: msg,
  //     life: 3000,
  //   });
  // };

  const validationSchema = Yup.object().shape({
    site: Yup.mixed().required("This field is required."),
    name: Yup.string()
      .required("This field is required.")
      .max(20, "max limit is 20"),
    direction: Yup.string()
      .required("This field is required.")
      .matches(
        /^[a-zA-Z][a-zA-Z ]+$/,
        "Numbers and special characters are not allowed"
      ),

    // state: Yup.mixed().required("This field is required."),
    location: Yup.string()
      .required("This field is required.")
      .max(50, "max limit is 50"),
    // longitude: Yup.mixed().required("This field is required."),
    // latitude: Yup.mixed().required("This field is required."),
    // active: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      site: "",
      name: "",
      direction: "",
      state: "",
      location: "",
      // longitude: "",
      // latitude: "",
      // active: "",
    },

    onSubmit: async (data) => {
      if (addEditBooth) {
        // handle editing user
        try {
          data["boothId"] = boothId;

          const response = await fetch(
            `${appUrl.BASE_URL}booth`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );

          if (response?.status === 201 || response?.status === 200) {
            toast.success("success");
            await getBoothList();
          }
          onHide();
        } catch (error) {
          console.error(error);
          const errorResponse = await error.response.json();
          const errorMsg = errorResponse?.msg || "An error occurred";
          // showWarn(errorMsg);
        }
      } else {
        try {
          const response = await fetch(
            `${appUrl.BASE_URL}booth`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(data),
            }
          );

          if (response?.status === 201 || response?.status === 200) {
            toast.success("success");
            await getBoothList();
          }
          onHide();
        } catch (error) {
          console.error(error);

          const errorResponse = await error.response.json();
          console.log("errorResponse", errorResponse);
          const errorMsg = errorResponse?.msg || "An error occurred";
          console.log("errorMsg", errorMsg);
          toast.error({ errorMsg });
          // showWarn(errorMsg);
        }
      }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const getBoothById = async () => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}booth/getById?boothId=${boothId}`
      );
      const keyData = await response.json();
      Object.keys(keyData?.data).forEach((key) => {
        if (formik.initialValues.hasOwnProperty(key)) {
          formik.setFieldValue(key, keyData?.data[key]);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data?.data);
    } catch (error) {
      console.error(error);
    }
  };


  const State = [
    { name: "Entrance", value:"entrance" },
     { name: "Exit",value:"exit" },
      { name: "Dual",value:"dual" }
  ];
  const directionOptions = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" },
    { label: "East", value: "East" },
    { label: "West", value: "West" },
  ];
  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site;
  console.log('userTypeIs', userTypeIs)
  useEffect(() => {
    formik.setFieldValue('site', userSite)
    setSitevalue(userSite)
  }, [userSite])

  useEffect(()=>{
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite)
 },[userSite,siteList])


  // const statusOption = [
  //   { name: "Active", status: true },
  //   { name: "InActive", status: false },
  // ];

  useEffect(() => {
    if (boothId !== undefined && boothId !== null && addEditBooth === true) {
      getBoothById();
    }
    getSiteList();
  }, []);

  return (
    <>
      {/* <Toast ref={toast} /> */}

      <h5 className="mb-5 ml-3 bold">{addEditBooth ? "Edit Booth" : "Add Booth"}</h5>
      <div className="brdr__top ">
        <form onSubmit={formik.handleSubmit}>
          <div className="card">
            <div className="p-fluid formgrid grid">
              <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}> Site </label>
                <span className={"Label__Required"} style={{ color: "red" }}>
                  *
                </span>

                <Dropdown
                  disabled={addEditBooth || siteValue?._id === formik.values.site}
                  id="site"
                  name="site"
                  value={formik.values.site?._id || formik.values.site}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("site") },
                    "TextArea__Round"
                  )}
                  options={siteList}
                  optionLabel="site"
                  optionValue="_id"
                  placeholder="--Select--"
                ></Dropdown>
                {getFormErrorMessage("site")}
              </div>


              <div className="field col-12 md:col-6">
                <label htmlFor="name" style={{ fontWeight: "bold" }}>
                  {" "}
                  Booth Name{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("name") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("name")}
              </div>

              {/* <div className="field col-12 md:col-6">
                <label htmlFor="direction" style={{ fontWeight: "bold" }}>
                  {" "}
                  Direction{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="direction"
                  name="direction"
                  value={formik.values.direction}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("direction") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("direction")}
              </div> */}
              <div className="field col-12 md:col-6">
                <label htmlFor="direction" style={{ fontWeight: "bold" }}>
                  Direction
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <Dropdown
                  id="direction"
                  name="direction"
                  value={formik.values.direction}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("direction") },
                    "TextArea__Round"
                  )}
                  options={directionOptions}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="--Select--"
                />
                {getFormErrorMessage("direction")}
              </div>
              {/* <div className="field col-12 md:col-6 my-pass">
                <label style={{ fontWeight: "bold" }}>State</label>
                <span className={"Label__Required"} style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="state"
                  name="state"
                  value={"dual"}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("state") },
                    "TextArea__Round"
                  )}
                  type="text"
                /> */}

              {/* {getFormErrorMessage("state")}
            </div> */}

              <div className="field col-12 md:col-6">
                <label htmlFor="location" style={{ fontWeight: "bold" }}>
                  {" "}
                  Location{" "}
                </label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <InputText
                  id="location"
                  name="location"
                  value={formik.values.location}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("location") },
                    "TextArea__Round"
                  )}
                  type="text"
                />
                {getFormErrorMessage("location")}
              </div>

              {/* <div className="field col-12 md:col-6">
                <label style={{ fontWeight: "bold" }}>Status</label>
                <span className="Label__Required" style={{ color: "red" }}>
                  *
                </span>
                <Dropdown
                  id="active"
                  name="active"
                  value={formik.values.active}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("active") },
                    "TextArea__Round"
                  )}
                  options={statusOption}
                  optionLabel="name"
                  optionValue="status"
                  placeholder="--Select--"
                />
                {getFormErrorMessage("active")}
              </div> */}
              <div className="field col-12 md:col-6 my-pass">
                <label style={{ fontWeight: "bold" }}>State</label>
                <span className={"Label__Required"} style={{ color: "red" }}>
                  *
                </span>
                <Dropdown
                  id="state"
                  name="state"
                  value={formik.values.state}
                  onChange={formik.handleChange}
                  className={classNames(
                    { "p-invalid": isFormFieldValid("state") },
                    "TextArea__Round"
                  )}
                  options={State}
                  optionValue="value"
                  optionLabel="name"
                  placeholder="--Select--"
                  filter
                // showClear
                // filterBy="gateRole"
                ></Dropdown>
                {getFormErrorMessage("state")}
              </div>
              <div className="col-12 text-center mt-6 flex justify-content-end">
                <Button
                  label="Cancel"
                  className="Cancel__button mr-3"
                  type="button"
                  onClick={onHide}
                />
                <Button
                  disabled={disable}
                  aria-label="Save"
                  type="submit"
                  className="Save__Button"
                  label={addEditBooth ? "Update" : "Save"}
                />
              </div>
            </div>
          </div>
        </form >
      </div >
    </>
  );
};

export default AddEditBooth;
